<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_TAGS" ppColor="primary-950"></pp-icon>
</div>

@if (
  (ppNotification.changeBody.newValue &&
  ppNotification.changeBody.newValue.length > ppNotification.changeBody.oldValue.length) ||
  !ppNotification.changeBody.oldValue
  ) {
  <span>
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{ 'the_following' | ppTranslate }}
    <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}:
  </span>
  <div class="notification__tags">
    @for (tag of ppNotification.changeBody.newValue; track tag) {
      @if (!ppNotification.changeBody?.oldValue.includes(tag)) {
        <pp-tag [ppText]="tag"></pp-tag>
      }
      }</div
      >
    }

    @if (
      (ppNotification.changeBody.oldValue &&
      ppNotification.changeBody.oldValue.length > ppNotification.changeBody.newValue.length) ||
      !ppNotification.changeBody.newValue
      ) {
      <span>
        <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
        {{ 'the_following' | ppTranslate }}
        <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
        {{ 'from_a_point_you' | ppTranslate }}
        {{ notificationReason }}:
      </span>
      <div class="notification__tags">
        @for (tag of ppNotification.changeBody.oldValue; track tag) {
          @if (!ppNotification.changeBody?.newValue.includes(tag)) {
            <pp-tag [ppText]="tag"></pp-tag>
          }
        }
      </div>
    }
